export const isNitroEnvironment = (): boolean =>
  window.location.hostname.includes('nitro.run');

export const isOrbitsEnvironment = (): boolean =>
  window.location.hostname.includes('orbits.run');
